import { AuditCenterSearchByFormatedEnum } from '@/types/audit-center-logs.types';
import {
  IWeekDay,
  IHealthKitLinkageUnitEnum,
  TaskIdentifierEnum,
  ILinkTaskTypeEnum,
  IDragOptions,
  HealthKitLinkageMethodEnum,
  PreferredCommunicationMethodEnum,
  TimeTrackerWidgetPurposeOfCallEnumm,
  RPMCohortViewColorsEnum,
  GenderEnum,
} from '@/types/generic.types';
import {
  SourcesForA1CEnum,
  TriagePriorityEnumCapitalized,
} from '@/types/patients.types';
import {
  IRpmPatientInformation,
  TimelineEventTypeEnum,
  type IDropdownOption,
} from '@/types/rpm-patient-information.types';
import {
  ListLayoutsEnum,
  ListColumnsEnum,
  DetailTemplatesEnum,
  DetailTabChartsEnum,
  DetailTabRowsEnum,
  IDetailTabObject,
  ListLayoutWidgetsEnum,
  DetailViewColumnsEnum,
  IDetailViewChartsWindowOption,
} from '@/types/views-types';
import { DefaultPrivacyLevelEnum } from '@/types/vuex-feature-flags-module.types';
import { RumInitConfiguration } from '@datadog/browser-rum';

export const linksMock: IDropdownOption[] = [
  {
    value: 0,
    id: ILinkTaskTypeEnum.WEBSITE,
    displayValue: ILinkTaskTypeEnum.WEBSITE,
  },
  {
    value: 1,
    id: ILinkTaskTypeEnum.URL,
    displayValue: ILinkTaskTypeEnum.URL,
  },
  {
    value: 2,
    id: ILinkTaskTypeEnum.CALL,
    displayValue: ILinkTaskTypeEnum.CALL,
  },
  {
    value: 3,
    id: ILinkTaskTypeEnum.MESSAGE,
    displayValue: ILinkTaskTypeEnum.MESSAGE,
  },
  {
    value: 4,
    id: ILinkTaskTypeEnum.EMAIL,
    displayValue: ILinkTaskTypeEnum.EMAIL,
  },
  {
    value: 5,
    id: ILinkTaskTypeEnum.LOCATION,
    displayValue: ILinkTaskTypeEnum.LOCATION,
  },
];

export const scheduleDaysMock: IDropdownOption[] = [
  {
    value: 0,
    displayValue: 'Weekly',
  },
  {
    value: 1,
    displayValue: 'Once a day',
  },
  {
    value: 2,
    displayValue: 'Twice a day',
  },
  {
    value: 3,
    displayValue: 'Three times a day',
  },
  {
    value: 4,
    displayValue: 'Four times a day',
  },
  {
    value: 5,
    displayValue: 'Five times a day',
  },
  {
    value: 6,
    displayValue: 'Six times a day',
  },
];

export const sourcesForA1CMock: IDropdownOption[] = [
  {
    value: 0,
    displayValue: SourcesForA1CEnum.SELECT,
  },
  {
    value: 1,
    displayValue: SourcesForA1CEnum.CLINIC,
  },
  {
    value: 2,
    displayValue: SourcesForA1CEnum.EHR,
  },
  {
    value: 3,
    displayValue: SourcesForA1CEnum.SELF_REPORT,
  },
];

export const daysCountSelection: IDropdownOption[] = [
  {
    value: 0,
    displayValue: '0',
  },
  {
    value: 1,
    displayValue: '1',
  },
  {
    value: 2,
    displayValue: '2',
  },
  {
    value: 3,
    displayValue: '3',
  },
  {
    value: 4,
    displayValue: '4',
  },
  {
    value: 5,
    displayValue: '5',
  },
  {
    value: 6,
    displayValue: '6',
  },
  {
    value: 7,
    displayValue: '7',
  },
];

export const unitsMock: IDropdownOption[] = [
  {
    value: 0,
    displayValue: IHealthKitLinkageUnitEnum.MG,
  },
  {
    value: 1,
    displayValue: IHealthKitLinkageUnitEnum.UNITS.toLowerCase(),
  },
];

export const methodsMock: IDropdownOption[] = [
  {
    value: 0,
    displayValue: HealthKitLinkageMethodEnum.ORAL,
  },
  {
    value: 1,
    displayValue: HealthKitLinkageMethodEnum.INJECTION,
  },
];

export const unitOfInputMock: IDropdownOption[] = [
  {
    value: 0,
    displayValue: IHealthKitLinkageUnitEnum.SEC,
  },
  {
    value: 1,
    displayValue: IHealthKitLinkageUnitEnum.MIN,
  },
];

export const unauthenticatedVendor = 'Unauthenticated';

export const pageTemplateMock: IDropdownOption[] = [
  {
    value: 0,
    displayValue: ListLayoutsEnum.ROWS,
  },
  {
    value: 1,
    displayValue: ListLayoutsEnum.WIDGETS_2_ROWS,
  },
  {
    value: 2,
    displayValue: ListLayoutsEnum.WIDGETS_3_ROWS,
  },
];

export const widgetsMock: IDropdownOption[] = [
  {
    value: 0,
    displayValue: ListLayoutWidgetsEnum.NO_WIDGET,
  },
  {
    value: 1,
    displayValue: ListLayoutWidgetsEnum.ADHERENCE_HISTOGRAM,
  },
  {
    value: 2,
    displayValue: ListLayoutWidgetsEnum.BLOOD_GLUCOSE_TREND_FIRST_30_DAYS,
  },
  {
    value: 3,
    displayValue: ListLayoutWidgetsEnum.BLOOD_GLUCOSE_TREND_FIRST_60_DAYS,
  },
  {
    value: 4,
    displayValue: ListLayoutWidgetsEnum.BLOOD_GLUCOSE_TREND_FIRST_90_DAYS,
  },
];

export const templatesMock: IDropdownOption[] = [
  {
    value: 0,
    displayValue: DetailTemplatesEnum.ROWS,
  },
  {
    value: 1,
    displayValue: DetailTemplatesEnum.TIME_SERIES_CHARTS,
  },
  {
    value: 2,
    displayValue: DetailTemplatesEnum.COLUMNS,
  },
  {
    value: 3,
    displayValue: DetailTemplatesEnum.COLUMNS_3,
  },
  {
    value: 4,
    displayValue: DetailTemplatesEnum.ROWS_AND_COLUMNS_3,
  },
];

export const prioritiesMock: IDropdownOption[] = [
  {
    value: 0,
    displayValue: TriagePriorityEnumCapitalized.HIGH,
  },
  {
    value: 1,
    displayValue: TriagePriorityEnumCapitalized.MEDIUM,
  },
  {
    value: 2,
    displayValue: TriagePriorityEnumCapitalized.LOW,
  },
  {
    value: 3,
    displayValue: TriagePriorityEnumCapitalized.NONE,
  },
];

export const tabChartsMock: IDropdownOption[] = [
  {
    value: 0,
    displayValue: DetailTabChartsEnum.BLOOD_GLUCOSE,
  },
  {
    value: 1,
    displayValue: DetailTabChartsEnum.INSULIN,
  },
  {
    value: 2,
    displayValue: DetailTabChartsEnum.SPACER,
  },
  {
    value: 3,
    displayValue: DetailTabChartsEnum.ACTIVITY,
  },
  {
    value: 4,
    displayValue: DetailTabChartsEnum.WEIGHT,
  },
  {
    value: 5,
    displayValue: DetailTabChartsEnum.ENGAGEMENT,
  },
  {
    value: 6,
    displayValue: DetailTabChartsEnum.ADHERENCE,
  },
  {
    value: 7,
    displayValue: DetailTabChartsEnum.HEART_RESTING,
  },
  {
    value: 8,
    displayValue: DetailTabChartsEnum.MEDICATIONS,
  },
];

export const sortingOrderMock: IDropdownOption[] = [
  {
    value: 0,
    displayValue: 'Ascending',
  },
  {
    value: 1,
    displayValue: 'Descending',
  },
];

export const tabRowsMock: IDropdownOption[] = [
  {
    value: 1,
    displayValue: DetailViewColumnsEnum.STICKIES,
    hidden: false,
  },
  {
    value: 2,
    displayValue: DetailViewColumnsEnum.CAREPLAN,
    hidden: false,
  },
  {
    value: 3,
    displayValue: DetailViewColumnsEnum.TIMELINE,
    hidden: false,
  },
];

export const daysMock: IWeekDay[] = [
  {
    index: 1,
    name: 'M',
    checked: false,
  },
  {
    index: 2,
    name: 'T',
    checked: false,
  },
  {
    index: 3,
    name: 'W',
    checked: false,
  },
  {
    index: 4,
    name: 'T',
    checked: false,
  },
  {
    index: 5,
    name: 'F',
    checked: false,
  },
  {
    index: 6,
    name: 'S',
    checked: false,
  },
  {
    index: 7,
    name: 'S',
    checked: false,
  },
];

export const bloodSugarMaxValue = 350;

export const heartRestingMaxValue = 150;

export const heartRestingHighThreshold = 100;

export const heartRestingVeryHighThreshold = 125;

export const bloodGlucoseVeryLowColor = '#B20000';

export const bloodGlucoseLowColor = '#EF3C3C';

export const bloodGlucoseTargetColor = '#2FC185';

export const bloodGlucoseHighColor = '#FF8E00';

export const bloodGlucoseVeryHighColor = '#F46700';

export const bloodPressureMaxValue = 150;

export const bloodPressureAverageValue = 100;

export const bloodPressureMinValue = 50;

export const insulinMaxValue = 30;

export const timeTrackerActiveTime = 300;

export const patientInformationTimeTracking = 5000; // in ms

export const glucoseCriticalHighDefault = 250;

export const glucoseHighDefault = 170;

export const glucoseLowDefault = 70;

export const glucoseCriticalLowDefault = 55;

export const bloodPressureCrisisDefault = 150;

export const bloodPressureStage2Default = 120;

export const bloodPressureStage1Default = 90;

export const bloodPressureHypotensionDefault = 70;

export const heartRestingCriticalLowDefault = 30;

export const heartRestingLowDefault = 50;

export const heartRestingHighDefault = 110;

export const heartRestingCriticalHighDefault = 130;

export const weightChangePoundsLowDefault = -30;

export const weightChangePoundsHighDefault = 30;

export const temperatureCriticalLowDefault = 0;
export const temperatureLowDefault = 99.4;
export const temperatureHighDefault = 100.9;
export const temperatureCriticalHighDefault = 101.0;

export const detailViewChartsWindowDefaultOption: IDetailViewChartsWindowOption =
  {
    time: '2_WEEKS',
  };

export const carePlanCatalogListHeaders: Array<string> = [
  'name',
  'measurement',
  'medication',
  'symptom',
  'lifestyle',
  'survey',
  'education',
  'link',
  'last_edited',
];

export const adminSettingsPatientsAssignedListHeaders: Array<string> = [
  'patient',
  'registration date',
  'uuid',
  'cohorts',
  'method',
];

export const adminSettingsPatientsUnassignedListHeaders: Array<string> = [
  'patient',
  'registration date',
  'uuid',
];

export const adminSettingsPatientsInactiveListHeaders: Array<string> = [
  'patient',
  'registration date',
  'deregistered date',
  'uuid',
  'deregistered method',
];

export const taskCategories: Array<TaskIdentifierEnum> = [
  TaskIdentifierEnum.MEASUREMENT,
  TaskIdentifierEnum.MEDICATION,
  TaskIdentifierEnum.SYMPTOMS,
  TaskIdentifierEnum.LIFESTYLE,
  TaskIdentifierEnum.EDUCATION,
  TaskIdentifierEnum.SURVEYS,
  TaskIdentifierEnum.LINKS,
  TaskIdentifierEnum.GOALS,
];

export const auditCenterListHeaders: Array<string> = [
  'category',
  'value',
  'detail',
  'user',
  'patient',
  'time',
  'source',
];

export const allAvailableColumns: ListColumnsEnum[] = [
  ListColumnsEnum.PATIENT,
  ListColumnsEnum.AGE,
  ListColumnsEnum.ENROLLED,
  ListColumnsEnum.ENGAGEMENT,
  ListColumnsEnum.ADHERENCE_7_DAYS,
  ListColumnsEnum.BG_BT_DAYS,
  ListColumnsEnum.BP_BT_DAYS,
  ListColumnsEnum.RESTING_HR,
  ListColumnsEnum.BLOOD_PRESSURE,
  ListColumnsEnum.BLOOD_GLUCOSE,
  ListColumnsEnum.STICKIES,
  ListColumnsEnum.WEIGHT_BT_DAYS,
  ListColumnsEnum.RH_BT_DAYS,
  ListColumnsEnum.GLUCOSE,
  ListColumnsEnum.CGM_GLUCOSE,
  ListColumnsEnum.WT_CHANGE_PERCENT_1_DAY,
  ListColumnsEnum.WT_CHANGE_PERCENT_2_DAY,
  ListColumnsEnum.WT_CHANGE_PERCENT_3_DAY,
  ListColumnsEnum.WT_CHANGE_PERCENT_1_WEEK,
  ListColumnsEnum.WT_CHANGE_PERCENT_2_WEEK,
  ListColumnsEnum.WT_CHANGE_PERCENT_1_MONTH,
  ListColumnsEnum.WT_CHANGE_POUNDS_1_DAY,
  ListColumnsEnum.WT_CHANGE_POUNDS_2_DAY,
  ListColumnsEnum.WT_CHANGE_POUNDS_3_DAY,
  ListColumnsEnum.WT_CHANGE_POUNDS_1_WEEK,
  ListColumnsEnum.WT_CHANGE_POUNDS_2_WEEK,
  ListColumnsEnum.WT_CHANGE_POUNDS_1_MONTH,
  ListColumnsEnum.GLUCOSE_TIME_IN_RANGE_7_DAYS,
  ListColumnsEnum.GLUCOSE_7_DAYS,
  ListColumnsEnum.GLUCOSE_TIME_IN_ZONE,
  ListColumnsEnum.GLUCOSE_TIME_IN_ZONE_4_WEEK,
  ListColumnsEnum.BP_TIME_IN_ZONE,
  ListColumnsEnum.PHONE_NUMBER,
  ListColumnsEnum.LATEST_GLUCOSE_MEASUREMENT,
  ListColumnsEnum.LATEST_WEIGHT_READING,
  ListColumnsEnum.LATEST_INSULIN_MEASUREMENT,
  ListColumnsEnum.LATEST_BLOOD_PRESSURE_MEASUREMENT,
  ListColumnsEnum.LATEST_IRREGULAR_HEART_RHYTHM_MEASUREMENT,
  ListColumnsEnum.LATEST_RESTING_HEART_RATE_MEASUREMENT,
  ListColumnsEnum.MESSAGES,
  ListColumnsEnum.CALORIES_2_WEEK,
];

export const defaultDetailViewTabs: IDetailTabObject[] = [
  {
    name: 'Overview',
    layout: DetailTemplatesEnum.ROWS,
    rows: [],
    widgets: [],
  },
  {
    name: 'Charts',
    layout: DetailTemplatesEnum.TIME_SERIES_CHARTS,
    rows: [
      DetailTabChartsEnum.BLOOD_GLUCOSE,
      DetailTabChartsEnum.INSULIN,
      DetailTabChartsEnum.SPACER,
      DetailTabChartsEnum.BLOOD_PRESSURE,
      DetailTabChartsEnum.SYMPTOMS,
      DetailTabChartsEnum.ACTIVITY,
      DetailTabChartsEnum.WEIGHT,
      DetailTabChartsEnum.CALORIES,
      DetailTabChartsEnum.SPACER,
      DetailTabChartsEnum.ENGAGEMENT,
      DetailTabChartsEnum.ADHERENCE,
      DetailTabChartsEnum.HEART_RESTING,
      DetailTabChartsEnum.MEDICATIONS,
      DetailTabChartsEnum.TEMPERATURE,
    ],
    widgets: [],
  },
  {
    name: 'Care Plan',
    layout: DetailTemplatesEnum.COLUMNS,
    rows: [],
    widgets: [DetailTabRowsEnum.CAREPLAN],
  },
];

export const dragOptions: IDragOptions = {
  animation: 200,
  group: 'draggable',
  disabled: false,
  ghostClass: 'ghost',
};

export const searchByOptions: IDropdownOption[] = [
  {
    value: 0,
    displayValue: AuditCenterSearchByFormatedEnum.NAME,
  },
  {
    value: 1,
    displayValue: AuditCenterSearchByFormatedEnum.PATIENT_USER_ID,
  },
  {
    value: 2,
    displayValue: AuditCenterSearchByFormatedEnum.USER_ID,
  },
];

export const defaultBackgroundImage =
  'https://a-us.storyblok.com/f/1016554/1280x901/6733c35294/foresight-login-default-background.png';

export const defaultLogoImage =
  'https://a-us.storyblok.com/f/1016554/892x282/2c6d6e586b/foresight-login-default-logo.png';

export const defaultDataDogConfiguration = {
  sessionSampleRate: 0,
  trackLongTasks: false,
  site: 'datadoghq.com' as RumInitConfiguration['site'],
  sessionReplaySampleRate: 0,
  applicationId: '',
  logLevelVerbosity: '',
  env: '',
  clientToken: '',
  service: '',
  trackUserInteractions: false,
  version: '',
  trackResources: false,
  defaultPrivacyLevel: DefaultPrivacyLevelEnum.MASK_USER_INPUT,
  trackFrustrations: false,
  allowedTracingUrls: [],
  traceSampleRate: 0,
};

export const menuOptionsMock: IDropdownOption[] = [
  {
    displayValue: 'Edit',
    value: 0,
  },
  {
    displayValue: 'Delete',
    value: 1,
  },
];

export const adminSettingsUsersListHeaders: Array<string> = [
  'clinician',
  'uuid',
  'mfa',
  'created',
  'role',
  'group',
];

export const preferredCommunicationMethodMock: IDropdownOption[] = [
  {
    value: 0,
    displayValue: PreferredCommunicationMethodEnum.DEFAULT,
  },
  {
    value: 1,
    displayValue: PreferredCommunicationMethodEnum.CALL,
  },
  {
    value: 2,
    displayValue: PreferredCommunicationMethodEnum.MESSAGE,
  },
];

export const timeTrackerWidgetPurposeOfCallMock: IDropdownOption[] = [
  {
    value: 0,
    displayValue: TimeTrackerWidgetPurposeOfCallEnumm.IT_SUPPORT,
  },
  {
    value: 1,
    displayValue: TimeTrackerWidgetPurposeOfCallEnumm.COACHING,
  },
  {
    value: 2,
    displayValue: TimeTrackerWidgetPurposeOfCallEnumm.CARE_TEAM_SUPPORT,
  },
];

export const validImageTypes = [
  'image/jpeg',
  'image/png',
  'image/gif',
  'image/svg+xml',
  'image/webp',
  'image/bmp',
];

export const validVideoTypes = [
  'video/mp4',
  'video/webm',
  'video/ogg',
  'video/avi',
  'video/mpeg',
  'video/quicktime',
  'video/x-matroska',
];

export const validDocumentTypes = ['application/pdf'];

export const timelineEventTypesToReview: string[] = [
  TimelineEventTypeEnum.BLOOD_GLUCOSE,
  TimelineEventTypeEnum.BLOOD_PRESSURE,
  TimelineEventTypeEnum.CGM,
  TimelineEventTypeEnum.INSULIN,
  TimelineEventTypeEnum.IRREGULAR_HEART_RHYTHM,
  TimelineEventTypeEnum.MEDICATION,
  TimelineEventTypeEnum.RESTING_HEART_RATE,
  TimelineEventTypeEnum.SYMPTOM,
  TimelineEventTypeEnum.SURVEY,
  TimelineEventTypeEnum.WEIGHT,
  TimelineEventTypeEnum.TRIAGE,
];

export const defaultPatientInformation: IRpmPatientInformation = {
  adherence: {
    aggregate: {
      average: 0,
      difference: 0,
      color: '',
      measurements: [],
      text: '',
    },
    activity: {
      average: 0,
      difference: 0,
      color: '',
      measurements: [],
      text: '',
    },
    glucose: {
      average: 0,
      difference: 0,
      color: '',
      measurements: [],
      text: '',
    },
    insulin: {
      average: 0,
      difference: 0,
      color: '',
      measurements: [],
      text: '',
    },
    medication: {
      average: 0,
      difference: 0,
      color: '',
      measurements: [],
      text: '',
    },
    weight: {
      average: 0,
      difference: 0,
      color: '',
      measurements: [],
      text: '',
    },
    bloodPressure: {
      average: 0,
      difference: 0,
      color: '',
      measurements: [],
      text: '',
    },
  },
  app: {
    platform: '',
    details: '',
    version: '',
    timestamp: '',
    engagement: {
      weight: {
        color: '',
        timestamp: null,
      },
      activity: {
        color: '',
        timestamp: null,
      },
      bloodGlucose: {
        color: '',
        timestamp: null,
      },
      insulin: {
        color: '',
        timestamp: null,
      },
      latest: {
        color: '',
        timestamp: null,
      },
    },
  },
  messages: {
    unreadMessages: 0,
  },
  recommendations: {
    latest: '',
    unread: 0,
  },
  bloodPressure: {
    systolic: {
      average: { color: RPMCohortViewColorsEnum.GRAY, value: 0 },
      max: { color: RPMCohortViewColorsEnum.GRAY, value: 0 },
      min: { color: RPMCohortViewColorsEnum.GRAY, value: 0 },
    },
    diastolic: {
      average: { color: RPMCohortViewColorsEnum.GRAY, value: 0 },
      max: { color: RPMCohortViewColorsEnum.GRAY, value: 0 },
      min: { color: RPMCohortViewColorsEnum.GRAY, value: 0 },
    },
    measurements: [],
    timeInZone: {
      hypotension: {
        value: 0,
        alert: false,
      },
      normal: {
        value: 0,
        alert: false,
      },
      elevated: {
        value: 0,
        alert: false,
      },
      stage1: {
        value: 0,
        alert: false,
      },
      stage2: {
        value: 0,
        alert: false,
      },
      crisis: {
        value: 0,
        alert: false,
      },
      total: 0,
    },
  },
  bgm: {
    average: {
      value: 0,
      color: RPMCohortViewColorsEnum.GRAY,
    },
    equivalentA1CAverage: 0,
    measurements: [],
    thresholds: {
      criticalHigh: 0,
      criticalLow: 0,
      high: 0,
      low: 0,
    },
    zonalChart: {
      high: 0,
      low: 0,
      target: 0,
      veryHigh: 0,
      veryLow: 0,
    },
  },
  cgm: {
    average: {
      value: 0,
      color: RPMCohortViewColorsEnum.GRAY,
    },
    equivalentA1CAverage: 0,
    measurements: [],
    thresholds: {
      criticalHigh: 0,
      criticalLow: 0,
      high: 0,
      low: 0,
    },
    zonalChart: {
      high: 0,
      low: 0,
      target: 0,
      veryHigh: 0,
      veryLow: 0,
    },
  },
  heartrate: {
    active: {
      average: { color: RPMCohortViewColorsEnum.GRAY, value: 0 },
      max: { color: RPMCohortViewColorsEnum.GRAY, value: 0 },
      min: { color: RPMCohortViewColorsEnum.GRAY, value: 0 },
      values: [],
    },
    irregular: {
      values: [],
    },
    resting: {},
  },
  engagement: {
    average: 0,
    measurements: [],
  },
  insulin: {
    basalBolusRatio: {
      basalPercent: 0,
      bolusPercent: 0,
    },
    fastActing: [],
    longActing: [],
  },
  medications: {},
  patient: {
    mrn: '',
    phone: '',
    sex: GenderEnum.MALE,
    birthday: '',
    careMode: '',
    clinicians: [],
    conditions: [],
    name: {
      givenName: '',
      familyName: '',
      middleName: '',
      namePrefix: '',
      nameSuffix: '',
      nickName: '',
      preferred: '',
    },
    email: '',
    patientId: '',
    phoneSecondary: '',
    pronouns: '',
    provider: {
      name: '',
      email: '',
      phone: '',
      serviceOrders: [],
    },
    tags: [],
    userId: '',
  },
  steps: {
    average: 0,
    max: 0,
    measurements: [],
    min: 0,
  },
  symptoms: [],
  temperature: null,
  tags: [],
  tagCategories: [],
  weight: {
    fluctuation: 0,
    max: 0,
    measurements: [],
    min: 0,
    reference: 0,
  },
  nutrition: {
    days: [
      {
        timestamp: '',
        macros: {
          calories: 0,
          carbohydrates: 0,
          fat: 0,
          fiber: 0,
          protein: 0,
          saturatedFat: 0,
          sodium: 0,
          sugar: 0,
        },
        food: [
          {
            name: '',
            macros: {
              calories: 0,
              carbohydrates: 0,
              fat: 0,
              fiber: 0,
              protein: 0,
              saturatedFat: 0,
              sodium: 0,
              sugar: 0,
            },
          },
        ],
      },
    ],
  },
};

export const defaultReportPatientInformation: IRpmPatientInformation = {
  adherence: {
    overall: {
      value: -1,
      color: '',
    },
    activity: {
      updated: '',
      value: -1,
      color: '',
      schedules: [],
    },
    bloodPressure: {
      updated: '',
      value: -1,
      color: '',
      schedules: [],
    },
    glucose: {
      updated: '',
      value: -1,
      color: '',
      schedules: [],
    },
    insulin: {
      updated: '',
      value: -1,
      color: '',
      schedules: [],
    },
    medication: {
      updated: '',
      value: -1,
      color: '',
      medications: [],
    },
    weight: {
      updated: '',
      value: -1,
      color: '',
      schedules: [],
    },
    zones: [],
  },
  app: {
    platform: '',
    details: '',
    version: '',
    timestamp: '',
    engagement: {
      weight: {
        color: '',
        timestamp: null,
      },
      activity: {
        color: '',
        timestamp: null,
      },
      bloodGlucose: {
        color: '',
        timestamp: null,
      },
      insulin: {
        color: '',
        timestamp: null,
      },
      latest: {
        color: '',
        timestamp: null,
      },
    },
  },
  messages: {
    unreadMessages: 0,
  },
  recommendations: {
    latest: '',
    unread: 0,
  },
  bloodPressure: {
    systolic: {
      average: { color: RPMCohortViewColorsEnum.GRAY, value: 0 },
      max: { color: RPMCohortViewColorsEnum.GRAY, value: 0 },
      min: { color: RPMCohortViewColorsEnum.GRAY, value: 0 },
    },
    diastolic: {
      average: { color: RPMCohortViewColorsEnum.GRAY, value: 0 },
      max: { color: RPMCohortViewColorsEnum.GRAY, value: 0 },
      min: { color: RPMCohortViewColorsEnum.GRAY, value: 0 },
    },
    measurements: [],
    timeInZone: {
      hypotension: {
        value: 0,
        alert: false,
      },
      normal: {
        value: 0,
        alert: false,
      },
      elevated: {
        value: 0,
        alert: false,
      },
      stage1: {
        value: 0,
        alert: false,
      },
      stage2: {
        value: 0,
        alert: false,
      },
      crisis: {
        value: 0,
        alert: false,
      },
      total: 0,
    },
  },
  bgm: {
    average: {
      value: 0,
      color: RPMCohortViewColorsEnum.GRAY,
    },
    equivalentA1CAverage: 0,
    measurements: [],
    thresholds: {
      criticalHigh: 0,
      criticalLow: 0,
      high: 0,
      low: 0,
    },
    zonalChart: {
      high: 0,
      low: 0,
      target: 0,
      veryHigh: 0,
      veryLow: 0,
    },
  },
  cgm: {
    average: {
      value: 0,
      color: RPMCohortViewColorsEnum.GRAY,
    },
    equivalentA1CAverage: 0,
    measurements: [],
    thresholds: {
      criticalHigh: 0,
      criticalLow: 0,
      high: 0,
      low: 0,
    },
    zonalChart: {
      high: 0,
      low: 0,
      target: 0,
      veryHigh: 0,
      veryLow: 0,
    },
  },
  heartrate: {
    active: {
      average: { color: RPMCohortViewColorsEnum.GRAY, value: 0 },
      max: { color: RPMCohortViewColorsEnum.GRAY, value: 0 },
      min: { color: RPMCohortViewColorsEnum.GRAY, value: 0 },
      values: [],
    },
    irregular: {
      values: [],
    },
    resting: {},
  },
  engagement: {
    average: 0,
    measurements: [],
  },
  insulin: {
    basalBolusRatio: {
      basalPercent: 0,
      bolusPercent: 0,
    },
    fastActing: [],
    longActing: [],
  },
  medications: {},
  patient: {
    mrn: '',
    phone: '',
    sex: GenderEnum.MALE,
    birthday: '',
    careMode: '',
    clinicians: [],
    conditions: [],
    name: {
      givenName: '',
      familyName: '',
      middleName: '',
      namePrefix: '',
      nameSuffix: '',
      nickName: '',
      preferred: '',
    },
    email: '',
    patientId: '',
    phoneSecondary: '',
    pronouns: '',
    provider: {
      name: '',
      email: '',
      phone: '',
      serviceOrders: [],
    },
    tags: [],
    userId: '',
  },
  steps: {
    average: 0,
    max: 0,
    measurements: [],
    min: 0,
  },
  symptoms: [],
  tags: [],
  tagCategories: [],
  weight: {
    fluctuation: 0,
    max: 0,
    measurements: [],
    min: 0,
    reference: 0,
  },
  nutrition: {
    days: [
      {
        timestamp: '',
        macros: {
          calories: 0,
          carbohydrates: 0,
          fat: 0,
          fiber: 0,
          protein: 0,
          saturatedFat: 0,
          sodium: 0,
          sugar: 0,
        },
        food: [
          {
            name: '',
            macros: {
              calories: 0,
              carbohydrates: 0,
              fat: 0,
              fiber: 0,
              protein: 0,
              saturatedFat: 0,
              sodium: 0,
              sugar: 0,
            },
          },
        ],
      },
    ],
  },
};

export const careModeOptions: string[] = [
  'Active',
  'Declined Visits',
  'Maintenance',
];

export const conditionsOptions: string[] = [
  'Type 1 Diabetes',
  'Type 2 Diabetes',
  'Diabetes & Pregnancy',
  'Hypertension',
  'Weight',
];

/**
 * Suffix shared by all codexhealth.com subdomain origins.
 * Use with event.origin.endsWith() for a CodeQL-recognised origin guard.
 */
export const codexHealthOriginSuffix = '.codexhealth.com';

/**
 * Exact origins that are always allowed in postMessage handlers
 * Use with Array.includes(event.origin) for a CodeQL-recognised origin guard.
 */
export const allowedExactOrigins: readonly string[] = [
  'https://codexhealth.com',
  'http://localhost:5173',
  'http://localhost:8080',
];
